import { Layout } from "react-admin";
import CustomMenu from "./custom-menu";
import CustomAppBar from "./custom-app-bar";
import { LayoutSX } from "../styled/custom";
import AffiliateSurveyDialog from "./affiliate-survey-dialog";

const CustomLayout = (props) => (
  <>
    <Layout
      {...props}
      menu={CustomMenu}
      appBar={CustomAppBar}
      sx={LayoutSX}
    />
    <AffiliateSurveyDialog />
  </>
);

export default CustomLayout;
